import { render, staticRenderFns } from "./cuentasbancarias.vue?vue&type=template&id=14152880&scoped=true"
import script from "./cuentasbancarias.vue?vue&type=script&lang=js"
export * from "./cuentasbancarias.vue?vue&type=script&lang=js"
import style0 from "./cuentasbancarias.vue?vue&type=style&index=0&id=14152880&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14152880",
  null
  
)

export default component.exports